// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 98 ? "b9fe42af" : chunkId) + "." + {"98":"2b502fbf0a3106e0","423":"6b8ed567038ec01f","550":"68e814b1f8c75a34","741":"79b583daf64bf8a5","880":"e0408d2a7cec4a7a","993":"e6af23fd50c40284"}[chunkId] + ".js";
};